/** Toont hoofdtaken (met subtaken) met een deadline binnen 7 dagen; verborgen als er geen zijn. */
import { Box, Typography } from '@mui/material';
import Panel from '@/components/ui/Panel';
import { useTasksContext } from '@/features/tasks';
import { getDayBoundaries, getTaskTime } from '@/features/tasks/utils/views/dailySectionsUtils';
import { isMainTask } from '@/features/tasks/components/atoms/taskMetadataViewState';
import { useT } from '@/i18n/useT';

const HORIZON_DAYS = 7;
const DAY_MS = 24 * 60 * 60 * 1000;

const TodayDeadlinesPanel = () => {
  const t = useT();
  const { filteredTasks, tasksMap } = useTasksContext();
  const { startOfToday } = getDayBoundaries();
  const horizonEnd = startOfToday + HORIZON_DAYS * DAY_MS;

  const deadlines = (filteredTasks || [])
    .filter((task) => {
      if (!isMainTask(task, tasksMap) || task.completed || !task.date) {
        return false;
      }
      const time = getTaskTime(task);
      return time >= startOfToday && time <= horizonEnd;
    })
    .sort((a, b) => getTaskTime(a) - getTaskTime(b));

  if (deadlines.length === 0) return null;

  return (
    <Panel
      flat
      testId="panel-deadlines"
      title={t('todayviewcontent.deadlines', 'Deadlines')}
      count={deadlines.length}
      tabIndex={-1}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, px: 1.5, py: 1 }}>
        {deadlines.map((task) => (
          <Typography key={task.id} variant="body2" noWrap title={task.title}>
            {task.title}
          </Typography>
        ))}
      </Box>
    </Panel>
  );
};

export default TodayDeadlinesPanel;
